import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DataObjectId, GTDStage} from 'yougile-model'
import {ChatSystemMessage} from '@components/common/base/chat-system-message'
import {ReferencedUser} from '@components/right-panel/chat/chat-messages/message/referenced-user'
import {SystemMessageProps} from '@components/right-panel/chat/chat-messages/message/types'

interface MessageContentProps {
  after: GTDStage | undefined
  by: DataObjectId
}

const MessageContent = ({after, by}: MessageContentProps) => {
  return (
    <>
      {Lang.msg.chat.gtdInfoPrefix} <ReferencedUser userId={by} guestId={by} />{' '}
      {Lang.msg.chat.gtdInfoSuffix(after === 'done')}
    </>
  )
}

export const GtdSystemMessage = ({
  message,
  className,
  animateShow
}: SystemMessageProps) => {
  const reason = message.properties.reason as string | undefined
  const after = message.properties.after as GTDStage | undefined
  const by = message.properties.actionBy as DataObjectId
  const icon =
    after === 'done' ? 'IconCustomTaskDoneFilled' : 'IconCustomTaskDoneEmpty'

  return (
    <ChatSystemMessage
      type="success"
      icon={icon}
      content={<MessageContent after={after} by={by} />}
      dateTime={Time.formatDateTime(message.timestamp)}
      timestamp={message.timestamp}
      className={className}
      animateShow={animateShow}
      additionalDevInfo={`gtd reason: ${reason}`}
    />
  )
}
